import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    TotalResAmount: 0,
    TotalDepFees: 0,
    TotalSchoolFeeswodisc: 0,
    TotalDiscount: 0,
    TotalFeesWithDiscount: 0,
    PayableAmount: 0,
    CustomAmount: 0,
    RemainingAmount: 0,
    AmountPaidFromAICCredit: 0,
    AmountPaidFromBpoint: 0,
    SelectedDiscountValue: 0,
    RemAmountMethod: '',
    MultipleCollegeChildren: [],
    paymentMethod: '',
    TransactionResponse: '',
    ReceiptNumber: 0,
    BillerCode: 0,
    MerchantNumber: 0,
};

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setFeeStructure: (state, action) => {
            state.TotalResAmount = action.payload.TotalResAmount;
            state.TotalDepFees = action.payload.TotalDepFees;
            state.TotalSchoolFeeswodisc = action.payload.TotalSchoolFeeswodisc;
            state.TotalDiscount = action.payload.TotalDiscount;
            state.TotalFeesWithDiscount = action.payload.TotalFeesWithDiscount;
            state.PayableAmount = action.payload.PayableAmount;
            state.SelectedDiscountValue = action.payload.SelectedDiscountValue;
        },
        setPaymentAmounts: (state, action) => {
            state.CustomAmount = action.payload.CustomAmount;
            state.RemainingAmount = action.payload.RemainingAmount;
            state.AmountPaidFromAICCredit = action.payload.AmountPaidFromAICCredit;
            state.AmountPaidFromBpoint = action.payload.AmountPaidFromBpoint;
            state.RemAmountMethod = action.payload.RemAmountMethod;
        },
        setPaymentMethod: (state, action) => {
            state.paymentMethod = action.payload;
        },
        setTransactionInfo: (state, action) => {
            state.TransactionResponse = action.payload.TransactionResponse;
            state.ReceiptNumber = action.payload.ReceiptNumber;
            state.BillerCode = action.payload.BillerCode;
            state.MerchantNumber = action.payload.MerchantNumber;
        },
        setMultipleCollegeChildren: (state, action) => {
            state.MultipleCollegeChildren = action.payload;
        },
        clearPayment: (state) => {
            return initialState;
        },
    },
});

export const {
    setFeeStructure,
    setPaymentAmounts,
    setPaymentMethod,
    setTransactionInfo,
    setMultipleCollegeChildren,
    clearPayment,
} = paymentSlice.actions;

export default paymentSlice.reducer;